/**
 * @namespace PIXI.mesh
 */
export { default as Mesh } from './Mesh';
export { default as MeshRenderer } from './webgl/MeshRenderer';
export { default as CanvasMeshRenderer } from './canvas/CanvasMeshRenderer';
export { default as Plane } from './Plane';
export { default as NineSlicePlane } from './NineSlicePlane';
export { default as Rope } from './Rope';
